import { createSlice } from "@reduxjs/toolkit";

export interface AccessPermissions {
  add: number;
  view: number;
  edit: number;
  approve: number;
  reject: number;
  cancel: number;
}

export interface ModuleAccess {
  menuItem: string;
  access: boolean;
  routes: Array<{
    path: string;
    permission: boolean;
    pageType: string;
  }>;
  add: number;
  view: number;
  edit: number;
  approve: number;
  reject: number;
  cancel: number;
}

export interface UserAccessibility {
  [moduleName: string]: ModuleAccess;
}

const initialState = {
  data: {} as UserAccessibility,
  loading: false,
  error: null,
};

export const accessibilitySlice = createSlice({
  name: "accessibility",
  initialState,
  reducers: {
    updateAccessibility: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    clearAccessibility: (state) => {
      state.data = {};
      state.loading = false;
      state.error = null;
    },
  },
});

export const { updateAccessibility, clearAccessibility } =
  accessibilitySlice.actions;
export default accessibilitySlice.reducer;
